import React from "react";
import {PropertyDefinitionDto} from "./apis/property/PropertyApi";

export interface DiagramPropertyDefinition {
    propertyDefinitions: PropertyDefinitionDto[];
    updatePropertyDefinitions: () => void;
}

const DiagramPropertyDefinitionContext = React.createContext<DiagramPropertyDefinition>({
    propertyDefinitions: [],
    updatePropertyDefinitions: () => {}
});

export default DiagramPropertyDefinitionContext;